export default "__VITE_ASSET__Bre9GU$Q__"